export interface StatusServicosVeicularModel {
    name?: string;
    descricao?: string;
    valor?: string[];
}

export const statusServicos: StatusServicosVeicularModel[] = [
    { valor: ["CRIADO"], descricao: "Criado" },
    { valor: ["PRECIFICADO"], descricao: "Precificado" },
    { valor: ["ABERTO"], descricao: "Aguardando aceitação" },
    { valor: ["EM_EXECUCAO"], descricao: "Solicitação em andamento" },
    { valor: ["PENDENTE_PAGAMENTO"], descricao: "Pendente pagamento" },
    { valor: ["FINALIZADO","PENDENTE_APROVACAO"], descricao: "Finalizado" },
    { valor: ["PRESTADOR_NAO_DISPONIVEL"], descricao: "Prestador não disponível para atendimento" },
    { valor: ["CANCELADO"], descricao: "Cancelado" }
];